//
//
//
//
//
//
//
//
//
//
//
//

import { getTime, getDate } from '@/utils/event/dateTime';

export default {
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    topic() {
      return this.$store.state.event.topic;
    },
    direction() {
      const id = this.event.directionId;
      if (!id) return;
      return this.$store.getters['eventsList/GET_DIRECTION_BY_ID'](id);
    },
    badges() {
      const list = [];

      if (this.direction?.name) list.push({ text: this.direction.name });
      list.push({ text: getDate(this, this.topic.topicDateUtc) });
      list.push({ text: getTime(this, this.topic.topicDateUtc) });

      return list;
    },
  },
};
